import type React from "react";
import { ActivitiesList } from "@/components/activities-list";

const ActivitiesPage: React.FC = () => {
  return (
    <>
      <main className="flex-1 space-y-6 p-2">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
            Activity Log
          </h2>
          <p className="text-muted-foreground">
            Complete history of events and actions
          </p>
        </div>

        <ActivitiesList />
      </main>
    </>
  );
};

export default ActivitiesPage;
